import { memo } from 'react';

import { Loading } from '@/components/core';
import {
  EmptyExportNodeContent,
  ExcelExportNodeContent,
  MakeExportNodeContent,
  N8NExportNodeContent,
  PowerAutomateExportNodeContent,
  WebhookExportNodeContent,
  ZapierExportNodeContent,
} from '@/components/flow';
import {
  EXPORT_TO_MAKE_FUNCTION_ID,
  EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID,
  EXPORT_TO_N8N_FUNCTION_ID,
  EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID,
  EXPORT_TO_WEBHOOK_FUNCTION_ID,
  EXPORT_TO_ZAPIER_FUNCTION_ID,
} from '@/constants';
import { useGetAgentFromPath } from '@/hooks';
import { toActionId, useGetAction } from '@/hooks/api';

export type ExportNodeProps = {
  actionId?: string;
};

const IExportNode = ({ actionId }: ExportNodeProps) => {
  const { data: agent, isPending: isPendingAgent } = useGetAgentFromPath();
  const { data: action } = useGetAction(toActionId(actionId));

  if (isPendingAgent) return <Loading label="Loading ..." />;
  if (!agent) return null;

  return (
    <div className="w-72">
      {action?.functionId === EXPORT_TO_WEBHOOK_FUNCTION_ID ? (
        <WebhookExportNodeContent agentId={agent.agentId} actionId={action.actionId} />
      ) : action?.functionId === EXPORT_TO_MICROSOFT_EXCEL_FUNCTION_ID ? (
        <ExcelExportNodeContent agentId={agent.agentId} actionId={action.actionId} />
      ) : action?.functionId === EXPORT_TO_POWER_AUTOMATE_FUNCTION_ID ? (
        <PowerAutomateExportNodeContent agentId={agent.agentId} actionId={action.actionId} />
      ) : action?.functionId === EXPORT_TO_ZAPIER_FUNCTION_ID ? (
        <ZapierExportNodeContent agentId={agent.agentId} actionId={action.actionId} />
      ) : action?.functionId === EXPORT_TO_MAKE_FUNCTION_ID ? (
        <MakeExportNodeContent agentId={agent.agentId} actionId={action.actionId} />
      ) : action?.functionId === EXPORT_TO_N8N_FUNCTION_ID ? (
        <N8NExportNodeContent agentId={agent.agentId} actionId={action.actionId} />
      ) : (
        <EmptyExportNodeContent agentId={agent.agentId} />
      )}
    </div>
  );
};

export const ExportNode = memo(IExportNode) as typeof IExportNode;
